export default {
  headerLineHeight: '1.4',
};
